import React, { useState, useEffect } from 'react';
import { NavLink,useNavigate } from "react-router-dom";
import { setYearList, setMonthList, setDateRange, formatDate , dynamicUrl } from './Function';
import { useDynamicLink } from './DynamicUse';
import { useAcdemicDepartmentList } from './DynamicUse';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, Table, Button, Placeholder, Form, Spinner } from 'react-bootstrap';

const Achievements = () => 
{
    const navigate = useNavigate();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const dynamicLinkData = useDynamicLink(229);
    const DepartmentList = useAcdemicDepartmentList();
    const [isLoading, setLoading] = useState(true);
    const [isLoadMore, setLoadMore] = useState(true);
    const [Rows, setRows] = useState(0);
    const [achievements, setAchievements] = useState([]);
    const [Department, setDepartment] = useState(Number(localStorage.getItem('setDepartment')) || 0);
    const [keyword, setKeyword] = useState('');
    const [year, setYear] = useState(0);
    const [month, setMonth] = useState(0);
    const DepartmentChange = (e) => {
        localStorage.removeItem('setDepartment');
        setDepartment(Number(e.target.value) || 0);
    };
    const KeywordChange = (e) => setKeyword(e.target.value.trim() || '');
    const YearChange = (e) => setYear(e.target.value > 0 ? Number(e.target.value) : 0);
    const MonthChange = (e) => setMonth(e.target.value > 0 ? Number(e.target.value) : 0);
    const handleAchievementsArchive = (sp) => 
    {
        localStorage.removeItem('setDepartment');
        navigate(dynamicUrl(sp));
    };
    useEffect(() => 
    {
        fetchAchievements(true);
        // eslint-disable-next-line
    }, []);
    const fetchAchievements = async (isReset) => 
    {
        if (isReset === true) 
        {
            setRows(0);  // Reset Rows if this is a new search
            setAchievements([]);  // Clear previous results
        }
        try
        {
            setLoading(true);
            var keywordText = keyword || 'none';
            const currentRows = isReset ? 0 : Rows;
            const { startDate, endDate } = setDateRange(year, month, 0, 0, 1);
            const callApi = global.config.API_URL + `achievements/list/${Department}/${keywordText}/${startDate}/${endDate}/${currentRows}`;
            if(global.config.IsPrint) console.info('fetchAchievements : API', callApi);
            const response = await fetch(callApi);
            const result = await response.json();
            if (result.length > 0) 
            {
                setAchievements(prevResults => Rows === 0 ? result : [...prevResults, ...result]);
                setRows(currentRows + 30);             
                setLoadMore(true);
            } 
            else 
            {
                setLoadMore(false);
            }
            if (global.config.IsPrint) console.info('fetchAchievements : Result', result);
        } 
        catch (error) 
        {
            console.error('fetchAchievements : Error', error.message);
        }
        finally 
        {
            setLoading(false);
        }
    };
    const handleSubmit = (e) => 
    {
        if (e)
        {
            e.preventDefault();
            if (Department === 0 && !keyword && year === 0 && month === 0) 
            {
                alert(t('FilterAlert'));
                return;
            }
        }
        fetchAchievements(true);
    }
    return (
        <Card className='mb-4'>
            <Card.Header className='text-center fs-3 text-uppercase'>{t('Achievements')}</Card.Header>
            <Card.Body>
                <Card className='mb-3'>
                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            <div className='mb-2 fw-bold'>{t('FilterSearch')}</div>
                            <Row className='g-2'>
                                <Col data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Select onChange={DepartmentChange} value={Department}>
                                        <option value={0}>{t('Department')}</option>
                                        {DepartmentList.map((sd,index) => (
                                        <option key={index} value={sd.sd_id}>
                                            {appLanguage === 'hi' ? sd.sd_name_hi || sd.sd_name : sd.sd_name}
                                        </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Control type="text" placeholder={t('FilterPlaceholder')} onChange={KeywordChange} value={keyword} />
                                </Col>
                                <Col data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Select onChange={YearChange} value={year}>
                                        <option value={0}>{t('FilterYear')}</option>
                                        {setYearList(0, 0).map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Select onChange={MonthChange} value={month}>
                                        <option value={0}>{t('FilterMonth')}</option>
                                        {setMonthList().map(({ value, label }) => (
                                            <option key={value} value={value}>
                                                {label}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col className='d-grid' data-aos="fade-left" data-aos-duration="1000">
                                    <Button type="submit" className='btn btn-info'><i className="bi bi-search"></i> {t('FilterSearch')}</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>                
                <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                    <thead>
                        <tr>
                            <th className='w-50'>{t('Title')}</th>
                            <th>{t('Department')}</th>
                            <th>{t('Download')}</th>
                            <th>{t('UploadDate')}</th>
                        </tr>
                    </thead>
                    {isLoading ? (
                    <tbody>
                        {[...Array(10)].map((_, index) => (
                            <tr key={index}>
                                <th className="table-success"><Placeholder xs={10} /></th>
                                <td className="text-center"><Placeholder xs={10} /></td>
                                <td className="text-center"><Button className="btn btn-light w-75"><Placeholder xs={12} /></Button></td>
                                <td className="text-center"><Placeholder xs={10} /></td>
                            </tr>
                        ))}
                    </tbody>
                    ) : (
                    <React.Fragment>
                    {achievements.length > 0 ? (
                        <tbody>
                            {achievements.map((sa, index) => (
                                <tr key={index}>
                                    <th className="table-success" dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? sa.sa_name_hi || sa.sa_name : sa.sa_name }}></th>
                                    <td className="text-center">{(appLanguage === 'hi' && sa.departments.sd_name_hi) ? sa.departments.sd_name_hi : sa.departments.sd_name}</td>
                                    <td className="text-center">
                                        <NavLink to={appLanguage === 'hi' ? `/उपलब्धि/विवरण/${sa.sa_htaccess_hi || sa.sa_htaccess}` : `/achievement/details/${sa.sa_htaccess}`} className="btn btn-light" target='_blank' rel="noopener noreferrer">{t('ViewDownload')}</NavLink>
                                    </td>
                                    <td className="text-center">{formatDate(sa.sa_date)}</td>
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <tbody>
                            <tr>
                                <td colSpan={4} className='text-center'>{t('NoResult')}</td>
                            </tr>
                        </tbody>
                    )}
                    </React.Fragment>                    
                )}
                </Table>
            </Card.Body>
            <Card.Footer className='d-flex justify-content-between bg-white'>
                {dynamicLinkData && dynamicLinkData.map((sp,index)=>(
                    <Button key={index} onClick={() => handleAchievementsArchive(sp)} variant='info'>
                        {t('Archives')}
                    </Button>
                ))}
                {isLoadMore &&
                <Button variant='info' onClick={() => fetchAchievements(false)} disabled={isLoading}>
                    {isLoading ? (
                    <React.Fragment>
                        <Spinner animation="grow" variant="light" size="sm" />
                        <Spinner animation="grow" variant="danger" size="sm" />
                        <span className='ms-2'>{t('PleaseWait')}</span>
                    </React.Fragment>
                    ) : t('LoadMore')}
                </Button>}
            </Card.Footer>
        </Card>
    );
};
export default Achievements;